// extracted by mini-css-extract-plugin
export default {"cls1":"NewsInteractionBar-cls1___30e0fe5b602c4bb56c5","cls2":"NewsInteractionBar-cls2__aa7b6efbb5d695798fd6 NewsInteractionBar-cls1___30e0fe5b602c4bb56c5"};